import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export const Navigation = (props) => {
  return (
    <nav
      id="menu"
      className="navbar navbar-nav navbar-expand-lg navbar-light bg-white fixed-top"
    >
      <div className="container">
        <a
          className="navbar-brand page-scroll"
          href="#/"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src="img/favicon.png"
            alt="Logo"
            style={{ height: "30px", marginRight: "10px" }}
          />
          jahnen
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="nav navbar-nav ms-auto">
            <li className="nav-item dropdown">
              <a href="#/" className="nav-link">
                Home
              </a>
            </li>
            <li className="nav-item dropdown">
              <a href="#services" className="nav-link">
                Services
              </a>
            </li>
            <li className="nav-item dropdown">
              <a href="#testimonials" className="nav-link">
                Reviews
              </a>
            </li>
            <li className="nav-item dropdown">
              <a href="#contact" className="nav-link">
                Contact
              </a>
            </li>
            <li className="nav-item">
              <a
                href="https://blog.jahnen.io"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                Blog
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
